import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = ({ children }) => {
  const { currentUser, isAdmin, loading } = useAuth(); // Get the loading state

  // While the initial auth check is running, show a loader.
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // After loading, if there's no user OR the user is not an admin, redirect.
  if (!currentUser || !isAdmin) {
    return <Navigate to="/login" />;
  }

  // If loading is finished and user is an admin, show the page.
  return children;
};

export default ProtectedRoute;